import { Fragment, h, JSX } from 'preact'
import { useState } from 'preact/hooks'

import { Loader } from './components/loader/loader'
import { Checkout, type CheckoutProps } from './modules/checkout/checkout'
import { GiftCard, type GiftCardProps } from './modules/gift-card/gift-card'
import { Response, type ResponseProps } from './modules/response/response'
import { SerialTicket, type SerialTicketProps } from './modules/serial-ticket/serial-ticket'

export interface RootProps {
    isLoading?: boolean
    checkout?: CheckoutProps
    giftCard?: GiftCardProps
    serialTicket?: SerialTicketProps
    response?: ResponseProps
}

export const Root = (props: RootProps): JSX.Element => {
    const cssPath = `${process.env.BASE_URL}/index.css`
    const [cssStatus, setCssStatus] = useState<'loading' | 'loaded' | 'failed'>('loading')

    // Avoid 'Flash of unstyled content' by delaying visible UI render until stylesheet is loaded
    const onCssLoaded = () => setCssStatus('loaded')
    const onCssFailed = () => setCssStatus('failed')

    return (
        <div>
            <link rel="stylesheet" href={cssPath} onLoad={onCssLoaded} onError={onCssFailed} />
            {props.isLoading && (
                <div class="root-loader">
                    <Loader />
                </div>
            )}
            {cssStatus === 'loaded' && (
                <Fragment>
                    {props.checkout && <Checkout {...props.checkout} />}
                    {props.giftCard && <GiftCard {...props.giftCard} />}
                    {props.serialTicket && <SerialTicket {...props.serialTicket} />}
                    {props.response && <Response {...props.response} />}
                </Fragment>
            )}
            {cssStatus === 'failed' && (
                <div style={{ textAlign: 'center', fontFamily: 'sans-serif', padding: 16 }}>
                    Error: Failed to load stylesheet
                </div>
            )}
        </div>
    )
}
